import { Card, CardContent } from '@/components/ui/card';
import { Pagination, PaginationContent, PaginationItem, PaginationLink } from '@/components/ui/pagination';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import type { PublicSession } from '@arrowise/shared';
import SessionListItem from './SessionListItem';

export interface SessionListProps {
    sessions: PublicSession[];
    onManage?: (sessionId: string) => void;
    onDelete?: (sessionId: string) => void;
    onView?: (sessionId: string) => void;
    canManageSession?: (session: PublicSession) => boolean;
    total?: number;
    currentPage?: number;
    limit?: number;
    onPageChange?: (page: number) => void;
    isFreeUser?: boolean;
}

export function SessionList({ sessions, onManage, onDelete, onView, canManageSession, total = 0, currentPage = 1, limit = 10, onPageChange, isFreeUser }: SessionListProps) {
    const empty = (!sessions || sessions.length === 0);
    if (empty) {
        return (
            <Card>
                <CardContent className="py-10 text-center text-muted-foreground">
                    No sessions yet.
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="space-y-6">
            <div className="flex flex-col gap-3">
                {sessions.map((s) => (
                    <SessionListItem
                        key={s.id}
                        session={s}
                        onManage={onManage}
                        onDelete={onDelete}
                        onView={onView}
                        canManageSession={canManageSession}
                        isFreeUser={isFreeUser}
                    />
                ))}
            </div>

            {total > limit && onPageChange && (
                <Pagination>
                    <PaginationContent>
                        <PaginationItem>
                            <PaginationLink
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage > 1) onPageChange(currentPage - 1);
                                }}
                                className="flex items-center gap-1"
                            >
                                <ChevronLeftIcon className="h-4 w-4" />
                            </PaginationLink>
                        </PaginationItem>
                        {Array.from({ length: Math.ceil(total / limit) }, (_, i) => i + 1).map(page => (
                            <PaginationItem key={page}>
                                <PaginationLink
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onPageChange(page);
                                    }}
                                    isActive={page === currentPage}
                                >
                                    {page}
                                </PaginationLink>
                            </PaginationItem>
                        ))}
                        <PaginationItem>
                            <PaginationLink
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage < Math.ceil(total / limit)) onPageChange(currentPage + 1);
                                }}
                                className="flex items-center gap-1"
                            >
                                <ChevronRightIcon className="h-4 w-4" />
                            </PaginationLink>
                        </PaginationItem>
                    </PaginationContent>
                </Pagination>
            )}
        </div>
    );
}

// SessionListItem moved to its own file: ./SessionListItem.tsx
